module.exports = __webpack_public_path__ + "img/131-chile.15c14817.svg";